import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card } from '../components/ui/card';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Berhasil masuk');
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Gagal masuk');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary/40 px-4">
      <Card className="w-full max-w-md p-8">
        <Link to="/" className="flex items-center gap-2 mb-6">
          <div className="h-9 w-9 rounded-lg bg-[hsl(var(--brand-gold))] flex items-center justify-center font-display font-bold text-[hsl(var(--brand-ink))]">G</div>
          <span className="font-display font-bold">Gold Trading Academy</span>
        </Link>
        <h1 className="font-display text-2xl font-bold">Masuk</h1>
        <p className="text-sm text-muted-foreground mt-1">Selamat datang kembali.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div><Label htmlFor="email">Email</Label><Input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} required data-testid="login-email-input" className="mt-1.5" /></div>
          <div><Label htmlFor="password">Kata Sandi</Label><Input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} required data-testid="login-password-input" className="mt-1.5" /></div>
          <Button type="submit" disabled={loading} className="w-full h-11 bg-[hsl(var(--brand-ink))] text-white" data-testid="login-submit-button">{loading ? 'Memproses...' : 'Masuk'}</Button>
        </form>
        <p className="text-sm text-muted-foreground mt-5 text-center">Belum punya akun? <Link to="/register" className="font-medium text-foreground underline">Daftar</Link></p>
      </Card>
    </div>
  );
}
